export default __webpack_public_path__ + "static/cf-ee187b0fdb2ebe781350a88e501f851b.svg";